module.exports = __webpack_public_path__ + "img/case-logo-1.140904da.png";